export default __webpack_public_path__ + "static/media/logo.9fa20109.svg";